import { DisplayContainer } from "../../../components/DisplayContainer";
import { IPeca, IPecaParaEntrega } from "../../Obras/newObra/IObra";



export function PecaDisplay({peca} : {peca: IPecaParaEntrega}) {



    return (
        <div className="border w-full rounded-md p-2 mt-2">
                <DisplayContainer prop={"Peça"} val={(peca.peca as IPeca).reference}/>
                <DisplayContainer prop={"Quantidade"} val={peca.quantidade}/>
                
            </div>
    )





}